import { RealTimeData } from "~types/types";
import isMarketOpen from "~transforms/isMarketOpen";
import { formatAsDateTimeISO } from "~utils/dateTimeUtils";

export default function priceUpdateDateTime(
  priceLastUpdated: string | null,
  realTimeData?: RealTimeData
) {
  const tradingDate = realTimeData?.tradingDate as string;
  const previousTradingDate = realTimeData?.previousTradingDate as string;

  const now = new Date();
  const marketOpenDateTime = formatAsDateTimeISO(
    tradingDate,
    realTimeData?.sessionStart as string
  );

  // when market is open, return price update datetime for current trading date
  // after market closed, return market close datetime for current trading date
  if (now >= marketOpenDateTime) {
    if (priceLastUpdated)
      return formatAsDateTimeISO(tradingDate, priceLastUpdated);

    if (isMarketOpen(tradingDate, realTimeData))
      // return event time when priceLastUpdated field is not available
      return formatAsDateTimeISO(
        tradingDate,
        realTimeData?.eventTime as string
      );

    return formatAsDateTimeISO(tradingDate, realTimeData?.sessionEnd as string);
  }

  // weekends, holidays and before market open, price update datetime is
  // market close time on previous trading date
  return formatAsDateTimeISO(
    previousTradingDate,
    realTimeData?.sessionEnd as string
  );
}
